import request from '@/config/axios'

export const getTripPage = (params: any) => {
  return request.get({ url: '/scenic/trip/page', params })
}

export const getTrip = (id: number) => {
  return request.get({ url: '/scenic/trip/get', params: { id } })
}

export const createTrip = (data: any) => {
  return request.post({ url: '/scenic/trip/create', data })
}

export const updateTrip = (data: any) => {
  return request.put({ url: '/scenic/trip/update', data })
}

export const deleteTrip = (id: number) => {
  return request.delete({ url: '/scenic/trip/delete', params: { id } })
}
